import { getFilterOptions } from 'api/Filter';

import {
  decimalIcdFormat,
  revertDecimalIcdFormat
} from 'components/practice/charts/ClinicalNote/shared/ICD10Code/lib/formatICD';

export const fetchFilterOptions = async (navigate, queryKey, pageParams) => {
  const category = queryKey.split('.')[0];

  const updatedSearchTerm =
    category === 'icd10_codes'
      ? revertDecimalIcdFormat(pageParams?.filters?.searchTerm)
      : (pageParams?.filters?.searchTerm ?? '');

  const updatedPageParams = {
    ...pageParams,
    filters: {
      ...pageParams.filters,
      searchTerm: updatedSearchTerm
    }
  };

  const filterOptions = await getFilterOptions(navigate, { category, ...updatedPageParams });
  const options =
    category === 'icd10_codes'
      ? decimalIcdFormat({ data: filterOptions.options, single: false })
      : filterOptions.options;

  return { ...filterOptions, options };
};
